import(/* webpackMode: "eager" */ "/vercel/path1/apps/web/src/app/(front)/(pages)/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/packages/i18n/src/Trans.tsx");
